/// <amd-module name="CodeCoverage/ViewCommon/Components/CoveredBarChart" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { css } from "VSSUI/Util";

export interface ICoveredBarChartProps {
    width: number;
    coveredPercentage: number;
    notCoveredCutoff: number;
    partiallyCoveredCutoff: number;
}

export class CoveredBarChart extends VssComponent<ICoveredBarChartProps> {
    public render(): JSX.Element {
        const { width, coveredPercentage, notCoveredCutoff: notCoveredCutOff, partiallyCoveredCutoff } = this.props;

        const coveredWidth = (coveredPercentage * this.props.width) / 100;

        let coveredBarClassName: string;
        let emptyBarClassName = "empty-bar";

        if (coveredPercentage < notCoveredCutOff) {
            coveredBarClassName = "not-covered-bar";
        } else if (coveredPercentage <= partiallyCoveredCutoff) {
            coveredBarClassName = "partial-covered-bar";
        } else {
            coveredBarClassName = "covered-bar";
        }

        if (coveredPercentage === 100) {
            coveredBarClassName = css(coveredBarClassName, "all-rounded-corners");
        } else if (coveredPercentage === 0) {
            emptyBarClassName = css(emptyBarClassName, "all-rounded-corners");
        } else {
            coveredBarClassName = css(coveredBarClassName, "left-rounded-corners");
            emptyBarClassName = css(emptyBarClassName, "right-rounded-corners");
        }

        return (
            <div className="cc-ci-bar-chart-container">
                <div className={coveredBarClassName} style={{ width: coveredWidth + "px" }} />
                <div className={emptyBarClassName} style={{ width: width - coveredWidth + "px" }} />
            </div>
        );
    }
}
